// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-O1_","top":"styles_top__3dwnR","left":"styles_left__1mruE","description":"styles_description__2C9pg"};